import wrapError from "@/components/helpers/wrapError"

export const apiGetRoleDonationStats = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/volunteer/roleDonationStats",
    success,
    error: wrapError(error, "apiGetRoleDonationStats"),
  })
}
